import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'components/Card'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { RegionPermissions, RegionFormParams } from 'models/region'
import { useUpdatePermissions } from 'services/user'
import { RegionForm } from 'features/shared/RegionForm'

type AreaPermissionsProps = {
  userId: string
  permissions: RegionPermissions
}

export const AreaPermissions: FC<AreaPermissionsProps> = ({ userId, permissions }) => {
  const { t } = useTranslation()
  const [updatePermissions] = useUpdatePermissions(userId)
  const [status, setStatus] = useState('idle')

  const onSubmit = (area: RegionFormParams) => {
    setStatus('loading')

    updatePermissions(
      { area },
      {
        onError: () => setStatus('error'),
        onSuccess: () => setStatus('success'),
        onSettled: () => {
          setTimeout(() => setStatus('idle'), 1000)
        },
      },
    )
  }

  return (
    <Card>
      <Stack space="large">
        <Stack space="xsmall">
          <Heading size="secondary">{t('user.edit.card.area.title')}</Heading>
          <Text>{t('user.edit.card.area.desc')}</Text>
        </Stack>

        <RegionForm
          country={permissions.country}
          state={permissions.state}
          state2={permissions.state2}
          state3={permissions.state3}
          status={status}
          submitArea={onSubmit}
          type="1"
        />
      </Stack>
    </Card>
  )
}

AreaPermissions.displayName = 'AreaPermissions'
